/* __next_internal_client_entry_do_not_use__ BookmarkTag auto */ import { SaleTag as ReactBookmarkTag } from "./SaleTag";
export var BookmarkTag = ReactBookmarkTag;
